import _ from 'lodash';

export default class User {
  constructor(data) {
    this.id = _.get(data, 'id', '');
    this.email = _.get(data, 'email', '');
    this.firstname = _.get(data, 'firstname', '');
    this.lastname = _.get(data, 'lastname', '');
    this.role = _.get(data, 'role', '');
    this.shopId = _.get(data, 'shopId', '');
    this.status = _.get(data, 'status', '');
  }

  get displayName() {
    return `${this.firstname} ${this.lastname}`;
  }
}
